export const SMALL_PHONE = '320px';
export const MEDIUM_PHONE = '375px';
export const LARGE_PHONE = '425px';

export const TABLET = '768px';

export const LAPTOP = '1024px';
export const LARGE_LAPTOP = '1440px';
